import { action } from 'satcheljs';

/**
 * This is used to notify other components the reading pane is closed.
 */
export default action('signalReadingPaneClosed', function signalReadingPaneClosed() {
    return {};
});
